import React, { Component } from 'react';
import { Navbar, Nav} from 'react-bootstrap';
import { Switch, Route } from 'react-router-dom';
import Home from './../Home';
import Projects from './../Projects';
import Contact from './../Contact';
import Resume from './../Resume';


export default class Navigation extends Component {

    render() {
        return (
            <div>


                <div>
                    <Navbar bg="light" expand="lg">
                        <Navbar.Brand href="/#/home">Senthil Muthuvel</Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="mr-auto">
                                <Nav.Link href="/#/home">Home</Nav.Link>
                                <Nav.Link href="/#/projects">Projects</Nav.Link>
                                <Nav.Link href="/#/contact">Contact</Nav.Link>
                                <Nav.Link href="/#/resume">Resume</Nav.Link>
                                {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                            </NavDropdown> */}

                            </Nav>
                            {/* <Form inline>
                            <FormControl type="text" placeholder="Search" className="mr-sm-2" />
                            <Button variant="outline-success">Search</Button>
                        </Form> */}
                        </Navbar.Collapse>
                    </Navbar>
                </div>
                <div>

                    <Switch>
                        {/* <Route exact path='/home' component={Home} /> */}
                        <Route exact path={`/`} render={ (routerProps) => < Home routerProps={routerProps} />} />
                        <Route exact path={`/home`} render={ (routerProps) => < Home routerProps={routerProps} />} />
                        {/* <Route exact path='/projects' component={Projects} /> */}
                        <Route exact path={`/projects`} render={ (routerProps) => < Projects routerProps={routerProps} />} />
                        {/* <Route exact path='/contact' component={Contact} /> */}
                        <Route exact path={`/contact`} render={ (routerProps) => < Contact routerProps={routerProps} />} />
                        {/* <Route exact path='/resume' component={Resume} /> */}
                        <Route exact path={`/resume`} render={ (routerProps) => < Resume routerProps={routerProps} />} />
                        <Route render={function () {
                            return <p>Not found</p>
                        }} />
                    </Switch>

                </div>
            </div>
        );
    }

}